/**
 * Wrapper to just prevent default event behavior and propagation
 *
 * @param callback {function|null} Optional callback to be executed
 * @return {function(*): *}
 */
export const stopEvent = (callback = null) => {

    /**
     * @param event {Event} Event to be handled
     */
    return event => {

        event.preventDefault();
        event.stopPropagation();

        callback?.call(null, event);
    };
};
